<template>
<body>
  <div>
    <h1>Privacy Statement</h1>

    <p>
      This Privacy Statement (the “Statement”) outlines the privacy practices of TheWishBoard, Inc. (“TheWishBoard,” “WishBoard,” “we,” or “us”) in relation to the website <a href="https://www.thewishboard.com">https://www.thewishboard.com</a> and its associated subdomains (the “Website”). The Statement details how we collect, use, and share information gathered through our Services. Please take the time to read this Statement, along with our <a href="https://www.thewishboard.com/TermsOfService">Terms of Service</a>.
    </p>

    <!-- Add the rest of your HTML content here -->


<pre>
Privacy Statement
This Privacy Statement (the “Statement”) outlines the privacy practices of TheWishBoard, Inc. (“TheWishBoard,” “we,” or “us”) in relation to the website https://www.thewishboard.com and its associated subdomains (the “Website”). The Statement details how we collect, use, and share information gathered through our Services. Please take the time to read this Statement, along with our Terms of Service available at https://www.thewishboard.com/TermsOfService.

**What Information We Collect**

We collect various types of information on TheWishBoard, including but not limited to:

1. **Contact Information:** Your name, address, email address, and telephone number.
2. **Account Login Information:** Information related to your account, including third-party account-verification details if you choose to sign in with Google.
3. **Financial Information:** Limited to payment card details, processed through our payment processor, Stripe. Refer to Stripe’s privacy policy at https://stripe.com/privacy.
4. **Network or Device Activity:** Information about the devices and browsers you use to access our Services, IP addresses, and interactions with our content.
5. **Location Information:** Geolocation data when using our Services.
6. **Electronic, Audio, Visual Information:** Communications with us, as well as photos, videos, or other content submitted in connection with our Services.

Additionally, users may provide demographic information related to life milestones, such as gender, age, marital status, and interests.

**How We Collect Information**

We collect information through three primary methods:

1. **Information You Provide:** When registering for an account, using our Services, or communicating with us.
2. **Information We Collect Automatically:** Through cookies, similar technologies, and analytics services (Google).
3. **Information From Other Sources:** Collected from other users or business partners, as permitted by applicable law.

**How We Use The Information**

We use the collected information to:

1. Provide and improve our Services.
2. Analyze and enhance user experience.
3. Process payments through a third-party payment processor.
4. Communicate with users and manage relationships.
5. Develop new applications or products.
6. Promote our Services through advertising materials.

We may also use aggregated information for research and product development.

**How We Share The Information**

We do not sell your information. We may share information in the following instances:

1. In connection with our Services.
2. With service providers and business partners, such as Digital Ocean, Google.
3. For legal reasons, business transfers, or with your consent.
4. Anonymized or aggregated information may be shared internally or with third parties.

**How You Can Manage Your Information**

If you have an account, you can manage your information by contacting us for full account data deletion at care@thewishboard.com.

**Where We Process Information**

Information may be processed globally, including in the United States, with potential variations in data protection levels. By using our Services, you acknowledge and understand this transfer.

**Data Subject Rights (EU)**

European Union residents have rights, including access, rectification, erasure, restriction of processing, objection to processing, and data portability. Contact us at care@thewishboard.com to exercise these rights.

**California Consumer Rights**

California consumers have the right to access, delete, and receive information about personal information categories collected. Wishboard does not sell personal information and does not discriminate against consumers exercising their rights. Contact us at care@thewishboard.com to make requests.

**Data Security**

We implement security measures but cannot guarantee absolute security. Data transmission risks exist.

**Data Retention**

We retain information as long as necessary for outlined purposes unless a longer period is legally required.

**Links to Other Sites**

Our Services may link to third-party sites. Review their privacy policies, as we are not responsible for their content or practices.

**Children’s Privacy**

Our Services are not intended for children under 13. If personal information is inadvertently collected, contact us for deletion at care@thewishboard.com.

**Changes to This Privacy Statement**

This Statement may be updated. Check this page periodically for changes. Updated Statements are effective immediately upon posting.

</pre>
    <p>
      <strong>Contact Us</strong><br>
      For questions or suggestions regarding this Privacy Statement, contact us at <a href="mailto:care@thewishboard.com">care@thewishboard.com</a>.
    </p>

    <p>
      <strong>LAST UPDATED:</strong> February 27, 2024
    </p>
  </div>
  </body>
</template>

<script>
export default {
  name: 'Privacy',
}
</script>

<style scoped>
    body {
      font-family: Arial, sans-serif;
      line-height: 1.6;
      max-width: 800px;
      /* margin-top: 20 px; */
      /* margin: auto; */
      padding: 25px;
    }

    pre {
      white-space: pre-wrap;
    }
/* Add your CSS styles here if needed */
</style>

